












import Vue from "vue";

export default Vue.extend({
  name: "Spinner",
  props: {
    msgKey: String,
    size: Number
  },
  computed: {
    cssVars() {
      if (!this.size) return {};

      return {
        "font-size": `${this.size}px`
      };
    }
  }
});
